import { firestore, auth } from "../firebase";
import { setSelectedQuestion } from "../redux/grSlice";
import store from "../redux/store";
import { captureException } from "../utils/errorHandlers";
import userAPI from "./user";
import { updateGrStateUiOnly, setStage } from "../redux/grSlice";
import { add } from "date-fns";
import { setSelectedInteractionId } from "../redux/interactionsSlice";
import { doc, setDoc } from "firebase/firestore";

const grAPI = {
  updateGrState: (payload) => {
    const state = store.getState();
    const userId = state.firebase.auth.uid;
    const textId = state.texts.selectedTextId;
    const isImpersonation = state.user?.original_auth !== -1;

    if (isImpersonation) store.dispatch(updateGrStateUiOnly(payload));
    else {
      const docRef = doc(firestore, `sq3r/${userId}/texts/textId`);
      setDoc(docRef, payload, { merge: true })
        .then(() => {
          const now = new Date();
          userAPI.log({
            action_name: "GR_STATE_UPDATE",
            user_id: userId,
            text_id: textId,
            created_at: now,
            ttl: add(now, { months: 1 }),
            payload: payload
          });
        })
        .catch((err) => {
          captureException(err, `Failed to save GR status to firebase`);
        });
    }
  },
  updateSelectedQuestionId: async function (qid) {
    const currentSelectedQuestionId =
      store.getState().interactions.selectedInteractionId;
    const selectedTextId = store.getState().texts.selectedTextId;
    try {
      const updateStr = new Date().toISOString();

      store.dispatch(setSelectedQuestion(qid));
      store.dispatch(setSelectedInteractionId(qid));

      const docRef = doc(
        firestore,
        `sq3r/${auth.currentUser.uid}/texts/${selectedTextId}`
      );
      await setDoc(
        docRef,
        {
          grQuestionId: qid,
          updatedAt: updateStr
        },
        { merge: true }
      );
    } catch (err) {
      captureException(
        err,
        `"Failed to update selected question id. user: ${auth.currentUser.uid}, questionId: ${qid} `
      );
      store.dispatch(setSelectedQuestion(currentSelectedQuestionId));
      store.dispatch(setSelectedInteractionId(currentSelectedQuestionId));
    }
  },
  updateSelectedStep: async function (step, prevStep) {
    const selectedTextId = store.getState().texts.selectedTextId;

    try {
      store.dispatch(setStage({ stage: step }));
      const updateStr = new Date().toISOString();
      if (prevStep !== step) {
        const docRef = doc(
          firestore,
          `sq3r/${auth.currentUser.uid}/texts/${selectedTextId}`
        );
        await setDoc(
          docRef,
          {
            grStage: step,
            updatedAt: updateStr
          },
          { merge: true }
        );
      }
    } catch (err) {
      captureException(err);
    }
  }
};

export default grAPI;
